import { Controller, useFormContext } from 'react-hook-form'

import { useTranslation } from '../localization'
import { Input, TelegramConturedMonoIcon } from '../ui-kit'

import { StartContent } from './start-content'
import { validateOptionalURL } from './validators'

interface TelegramUrlFormControlContext {
  telegramUrl: string | undefined
}

export const TelegramUrlFormControl = <
  _FormContext extends TelegramUrlFormControlContext,
>() => {
  const { t } = useTranslation()
  const formContext = useFormContext<TelegramUrlFormControlContext>()

  return (
    <Controller
      control={formContext.control}
      rules={{
        validate: (url) =>
          validateOptionalURL({
            url,
            domains: ['t.me'],
          }) || t('premium.form.invalid-url-telegram'),
      }}
      name="telegramUrl"
      render={({ field, fieldState }) => (
        <Input
          {...field}
          size="m"
          placeholder="https://t.me/example"
          error={fieldState.error?.message}
          startContent={
            <StartContent
              icon={<TelegramConturedMonoIcon height={15} width={15} />}
            >
              {t('common.telegram')}
            </StartContent>
          }
        />
      )}
    />
  )
}
